import React, { useEffect, useRef, memo } from "react";

const darkMode = localStorage.getItem("darkMode") === "true";

// DOC: https://www.tradingview.com/widget-docs/widgets/charts/advanced-chart/

function TradingViewChart () {
    const container = useRef();
    useEffect(
        () => {
            const script = document.createElement("script");
            script.src = "https://s3.tradingview.com/external-embedding/embed-widget-advanced-chart.js";
            script.type = "text/javascript";
            script.async = true;
            script.innerHTML = `
            {
                "autosize": true,
                "symbol": "BINANCE:BTCUSDT.P",
                "interval": "5",
                "timezone": "Asia/Singapore",
                "theme": "${darkMode ? "dark" : "light"}",
                "style": "1",
                "locale": "en",
                "enable_publishing": false,
                "withdateranges": true,
                "allow_symbol_change": true,
                "save_image": true,
                "watchlist": [
                    "BINANCE:BTCUSDT.P",
                    "BINANCE:ETHUSDT.P",
                    "BINANCE:BNBUSDT.P",
                    "BINANCE:BZUSDT.P",
                    "BINANCE:CLUSDT.P",
                    "BINANCE:SKHYUSDT.P",
                    "BINANCE:SKHYNIXUSDT.P",
                    "BINANCE:XAUUSDT.P",
                    "BINANCE:MSTRUSDT.P",
                    "BINANCE:CRCLUSDT.P",
                    "BINANCE:COINUSDT.P",
                    "BINANCE:HOODUSDT.P",
                    "OANDA:NAS100USD",
                    "OANDA:SPX500USD",
                    "BINANCE:SOLUSDT.P",
                    "BINANCE:HYPEUSDT.P",
                    "BINANCE:ETHBTC",
                    "BINANCE:BNBBTC",
                    "KRAKEN:USDTUSD",
                    "KRAKEN:USDCUSD",
                    "FX:USDCNH"
                ],
                "hotlist": true,
                "details": true
            }`;
            container.current.appendChild(script);
        }, []
    );

    return (<div className="tradingview-widget-container" ref={container}/>);
}

export default memo(TradingViewChart);


// WEBPACK FOOTER //
// ./src/component/TradingViewChart.jsx